import { ReactNode } from "react";

import { Icon } from "kit/ui";

import { useRadioCardContext } from "./RadioCard";

import * as styles from "./RadioCard.styles";

interface RadioCardOptionProps {
  value: string;
  children: ReactNode;
  disabled?: boolean;
}

function RadioCardOption({
  value,
  children,
  disabled
}: RadioCardOptionProps) {

  const { name, selectedValue, onChange, disabled: groupDisabled } = useRadioCardContext();

  const isSelected = selectedValue === value;
  const isDisabled = disabled || groupDisabled;

  const handleChange = () => {
    if (!isDisabled) {
      onChange(value);
    }
  };

  return (
    <label css={styles.radioOption(isSelected, isDisabled)}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={isSelected}
        disabled={isDisabled}
        css={styles.hiddenInput}
        onChange={handleChange} />
      <div css={styles.optionContent}>{children}</div>
      {isSelected && (
        <span aria-hidden="true">
          <Icon
            name="myk check-circle"
            css={styles.checkIcon} />
        </span>
      )}
    </label>
  );
}

RadioCardOption.displayName = "RadioCardOption";

export default RadioCardOption;
